const MOCK_MEALS = ["Vegetable Upma", "Moong Dal Chilla", "Buttermilk with Roasted Chana"];

const MiniRing = ({ pct }) => {
  const r = 42;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative w-[100px] h-[100px] flex items-center justify-center" data-testid="mock-consistency-ring">
      <svg width="100" height="100" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r={r} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="8" />
        <circle
          cx="50"
          cy="50"
          r={r}
          fill="none"
          stroke="#B37FE8"
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c - (c * pct) / 100}
          transform="rotate(-90 50 50)"
          style={{ filter: "drop-shadow(0 0 8px rgba(179,127,232,0.5))" }}
        />
      </svg>
      <span className="absolute text-lg font-semibold text-kaizen-text">{pct}%</span>
    </div>
  );
};

export const DashboardMockSection = () => {
  return (
    <section className="py-24 md:py-32" data-testid="dashboard-mock-section">
      <div className="max-w-md mx-auto px-6 sm:px-10 text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-kaizen-dim" data-testid="dashboard-mock-label">
          This is how it works
        </p>

        <div className="glass-card rounded-[2rem] p-6 mt-8 text-left" data-testid="dashboard-mock-card">
          <p className="text-sm text-kaizen-dim" data-testid="mock-nova-line">
            Rough day noted. Twelve minutes at home keeps the chain alive — small beats zero.
          </p>

          <div className="flex items-center justify-between mt-5">
            <div>
              <p className="text-xs uppercase tracking-widest text-kaizen-dim2">Today</p>
              <p className="font-display text-lg text-kaizen-text mt-0.5" data-testid="mock-session-label">
                12-Minute Floor — at home
              </p>
            </div>
            <span
              className="text-xs px-3 py-1 rounded-full border text-ready-amber border-ready-amber/40 bg-ready-amber/10"
              data-testid="mock-floor-day-badge"
            >
              Floor day
            </span>
          </div>

          <div className="flex gap-2 mt-5 flex-wrap" data-testid="mock-meals-row">
            {MOCK_MEALS.map((m) => (
              <span
                key={m}
                className="text-xs px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.08] text-kaizen-dim"
              >
                {m}
              </span>
            ))}
          </div>

          <div className="flex flex-col items-center mt-7">
            <MiniRing pct={96} />
            <p className="text-xs text-kaizen-dim mt-3" data-testid="mock-consistency-line">
              On this pace — still on track
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
